import DefinitionFormModal from './DefinitionFormModal';

export default DefinitionFormModal;
